// extracted by mini-css-extract-plugin
module.exports = {"fieldWrapper":"ParticipationFormat_fieldWrapper__QoovM","label":"ParticipationFormat_label__tp1vd","text":"ParticipationFormat_text__XM0Ym"};